import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicPartnersUniversitiesServiceCompany({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle stroke="#F4F5FB" strokeWidth={8} cx={18} cy={58} r={14} />
        <circle stroke="#F4F5FB" strokeWidth={8} cx={20} cy={20} r={12} />
        <circle stroke="#F4F5FB" strokeWidth={8} cx={58} cy={40} r={18} />
        <path d="M51 40a7 7 0 0014 0" stroke="#F4F5FB" strokeWidth={8} strokeLinecap="round" />
        <path d="M11 58h14a7 7 0 01-14 0z" fill="#F4F5FB" />
      </g>
    </svg>
  );
}

SvgPicPartnersUniversitiesServiceCompany.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicPartnersUniversitiesServiceCompany.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicPartnersUniversitiesServiceCompany svgRef={ref} {...props} />
));
export default ForwardRef;
